/* Package JSON Import will be here */
import React, { Fragment } from "react";
import { Header, Segment, Button, Form, TextArea, Icon, Grid, Modal } from 'semantic-ui-react';
import ImageUploading from "react-images-uploading";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Constants } from '../../../config/appConstants';
import AttachmentViewer from '../../sharedComponent/attachmentViewer/attachmentViewer.Container';
import ConfirmationPopup from "./TMVoucherComponents/ConfirmationPopup";
import Loader from "../../sharedComponent/loader/loader";
import "./TMVoucherStyle.css";
import TMVoucherSignature from "./TMVoucherComponents/TMVoucherSignature";
/* Project Import will be here */

const TmVoucherDataEntryComponent = (props) => {

    const DataEntryPage = () => (
        <Segment.Group>
            <Segment className="stickyHeader zIndex-14">
                <Header as="h3" size='tiny' textAlign='center'>{Constants.TM_VOUCHER_TAB_HEADER}</Header>
            </Segment>

            <Segment className="overflowScroll pb-3 color-black" style={{ height: 'calc(97vh - 71px)', backgroundColor: '#fff' }}>
                <div className="descriptionWidth">
                    <div className="ptb-2 borderBottom text-center font-weight-600">{Constants.TM_VOUCHER_DATA_ENTRY_HEADER}</div>
                    <div className="ptb-2 bgColorReport borderBottom text-center font-weight-600">{`${props.tmVoucherDataEntry.selectedTMVoucher.projectNumber} - ${props.tmVoucherDataEntry.selectedTMVoucher.taskNumber}-${props.tmVoucherDataEntry.selectedTMVoucher.taskName}`}</div>
                    <header className="ptb-2 bgColorReport borderBottom text-center font-weight-600" as="h5" size="tiny" textalign='center'>Description of Work</header>
                    <TextArea rows="3" className="w-100 borderNone p-2 reSizeNone textDescription" maxLength="1000"
                        value={props.tmVoucherDataEntry.tmVoucherList.descriptionOfWork}
                        onChange={(e, { value }) => props.handleInputChange(value, 0, Constants.DESCRIPTION_OF_WORK)}
                    />
                </div>

                {/* TM VOUCHER EQUIPMENT */}
                <div className="descriptionWidthTable mt-5">
                    <Form>
                        <Grid className="m-0 text-center ">
                            <Grid.Row className="font-weight-600 p-0 bgColorReport">
                                <Grid.Column width={3} className="ptb-2 borderWidth-1">
                                    Unit#
                                </Grid.Column>
                                <Grid.Column width={3} className="ptb-2 borderWidth-1">
                                    Hour
                                </Grid.Column>
                                <Grid.Column width={3} className="ptb-2 borderWidth-1">
                                    Days
                                </Grid.Column>
                                <Grid.Column width={5} className="ptb-2 borderWidth-1">
                                    Equipment
                                </Grid.Column>
                                <Grid.Column width={2} className="ptb-2 borderWidth-1 borderRight">
                                    <Icon name="plus" className="pointer" onClick={props.onClickAddTmEquipment} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Grid className="gridColumnReverse m-0 text-center">
                            {props.tmVoucherDataEntry.tmVoucherList.tmEquipments.map((equipment, index) => (
                                !equipment.isDeleted && (
                                    <Grid.Row className="contentOtherInput boldTextdisabled p-0" key={index}>
                                        <Grid.Column width={3} className="p-0 borderWidth-2">
                                            <Form.Field className="h-100">
                                                <TextArea rows={1} fluid="true" className="textAreaWrapping cardInput-1 focusInput" maxLength="255"
                                                    value={equipment.equipmentUnitNumber}
                                                    onChange={(e, { value }) => props.handleInputChange(value, index, Constants.EQUIPMENT_UNIT)}
                                                />
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={3} className="p-0 borderWidth-2">
                                            <Form.Field >
                                                <Form.Input fluid={true} className="cardInput-1" maxLength="5"
                                                    value={equipment.equipmentHours}
                                                    onChange={(e, { value }) => props.handleInputChange(value, index, Constants.EQUIPMENT_HOURS)}
                                                />
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={3} className="p-0 borderWidth-2">
                                            <Form.Field className="h-100">
                                                <TextArea rows={1} fluid="true" className="textAreaWrapping cardInput-1 focusInput" maxLength="5"
                                                    value={equipment.equipmentDays}
                                                    onChange={(e, { value }) => props.handleInputChange(value, index, Constants.EQUIPMENT_DAYS)}
                                                />
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={5} className="p-0 borderWidth-2">
                                            <Form.Field className="tmVoucherEquipment">
                                                <Form.Select className="cardInput-1 focusInput borderNone paddingBottom"
                                                    fluid={true}
                                                    placeholder='Select Description'
                                                    selectOnBlur={false}
                                                    options={props.tmVoucherDataEntry.equipmentOptions}
                                                    value={equipment.equipmentValue}
                                                    onChange={(e, { value }) => props.handleInputChange(value, index, Constants.EQUIPMENT_DROPDOWN)}
                                                />
                                                {equipment.equipmentValue === Constants.OTHER && (
                                                    <TextArea style={{ paddingLeft: '8px' }} value={equipment.equipmentDescription}
                                                        className="dailyEquipmentTextArea"
                                                        onChange={(e, { value }) => props.handleInputChange(value, index, Constants.EQUIPMENT_DESCRIPTION)}
                                                        fluid="true"
                                                        placeholder="Description"
                                                        maxLength="50"
                                                    />
                                                )}
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={2} className="p-0 borderWidth-2 borderRight lineHeight-1">
                                            <Form.Field className="h-100 d-flex justify-content-center align-items">
                                                <Icon style={{ color: '#ca1413' }} name="trash" className="pointer iconColor" onClick={() => props.onClickDelete(index, Constants.TM_EQUIPMENT)} />
                                            </Form.Field>
                                        </Grid.Column>
                                    </Grid.Row>
                                )))}
                        </Grid>
                    </Form>
                </div>

                {/* TM VOUCHER MATERIAL */}
                <div className="descriptionWidthTable mt-5">
                    <Form>
                        <Grid className="m-0 text-center ">
                            <Grid.Row className="font-weight-600 p-0 bgColorReport">
                                <Grid.Column width={3} className="ptb-2 borderWidth-1">
                                    Qty
                                </Grid.Column>
                                <Grid.Column width={3} className="ptb-2 borderWidth-1">
                                    Size
                                </Grid.Column>
                                <Grid.Column width={8} className="ptb-2 borderWidth-1">
                                    Description of Material
                                </Grid.Column>
                                <Grid.Column width={2} className="ptb-2 borderWidth-1 borderRight">
                                    <Icon name="plus" className="pointer" onClick={props.onClickAddTMMaterial} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Grid className="gridColumnReverse m-0 text-center">
                            {props.tmVoucherDataEntry.tmVoucherList.tmMaterials.map((material, index) => (
                                !material.isDeleted && (
                                    <Grid.Row className="contentOtherInput boldTextdisabled p-0" key={index}>
                                        <Grid.Column width={3} className="p-0 borderWidth-2">
                                            <Form.Field className="h-100">
                                                <TextArea rows={1} fluid="true" className="textAreaWrapping cardInput-1 focusInput" maxLength="10"
                                                    value={material.materialQuantity}
                                                    onChange={(e, { value }) => props.handleInputChange(value, index, Constants.MATERIAL_QUANTITY)}
                                                />
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={3} className="p-0 borderWidth-2">
                                            <Form.Field className="h-100">
                                                <TextArea rows={1} fluid="true" className="textAreaWrapping cardInput-1 focusInput" maxLength="255"
                                                    value={material.materialSize}
                                                    onChange={(e, { value }) => props.handleInputChange(value, index, Constants.MATERIAL_SIZE)}
                                                />
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={8} className="p-0 borderWidth-2">
                                            <Form.Field className="h-100">
                                                <Form.Dropdown className="m-0 selectDropdownTMDescription"
                                                    fluid
                                                    search={(options, value) => options.filter(a => a.searchText.toLowerCase().replace(/\s/g, '').includes(value.toLowerCase().replace(/\s/g, '')))}
                                                    selection
                                                    value={material.materialValue}
                                                    options={props.tmVoucherDataEntry.materialOptions}
                                                    onChange={(e, { value }) => props.handleInputChange(value, index, Constants.MATERIAL_DROPDOWN)}
                                                    selectOnBlur={false}
                                                />
                                                {material.materialValue === Constants.OTHER && (
                                                    <TextArea style={{ paddingLeft: '8px' }} value={material.materialDescription}
                                                        className="tmMaterialTextArea"
                                                        onChange={(e, { value }) => props.handleInputChange(value, index, Constants.MATERIAL_DESCRIPTION)}
                                                        fluid="true"
                                                        placeholder="Description"
                                                        maxLength="50"
                                                    />
                                                )}
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={2} className="p-0 borderWidth-2 borderRight lineHeight-1">
                                            <Form.Field className="h-100 d-flex justify-content-center align-items">
                                                <Icon style={{ color: '#ca1413' }} name="trash" className="pointer iconColor" onClick={() => props.onClickDelete(index, Constants.TM_MATERIAL)} />
                                            </Form.Field>
                                        </Grid.Column>
                                    </Grid.Row>
                                )))}
                        </Grid>
                    </Form>
                </div>

                {/* TM MISCELLANEOUS */}
                <div className="descriptionWidthTable mt-5">
                    <div className="ptb-2 borderTop borderLeft borderRight text-center font-weight-600">{Constants.TM_MISCELLANEOUS_SECTION_HEADER}</div>
                    <Form>
                        <Grid className="m-0 text-center ">
                            <Grid.Row className="font-weight-600 p-0 bgColorReport">
                                <Grid.Column width={7} className="ptb-2 borderWidth-1">
                                    Type
                                </Grid.Column>
                                <Grid.Column width={7} className="ptb-2 borderWidth-1">
                                    Description
                                </Grid.Column>
                                <Grid.Column width={2} className="ptb-2 borderWidth-1 borderRight">
                                    <Icon name="plus" className="pointer" onClick={props.onClickAddTMMiscellaneous} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Grid className="gridColumnReverse m-0 text-center">
                            {props.tmVoucherDataEntry.tmVoucherList.tmMiscellaneous.map((miscellaneous, index) => (
                                !miscellaneous.isDeleted && (
                                    <Grid.Row className="contentOtherInput boldTextdisabled p-0" key={index}>
                                        <Grid.Column width={7} className="p-0 borderWidth-2">
                                            <Form.Field className="h-100">
                                                <TextArea rows={1} fluid="true" className="textAreaWrapping cardInput-1 focusInput" maxLength="1000"
                                                    value={miscellaneous.miscType}
                                                    onChange={(e, { value }) => props.handleInputChange(value, index, Constants.TM_MISCELLANEOUS_TYPE)}
                                                />
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={7} className="p-0 borderWidth-2">
                                            <Form.Field className="h-100">
                                                <TextArea rows={1} fluid="true" className="textAreaWrapping cardInput-1 focusInput" maxLength="1000"
                                                    value={miscellaneous.miscDescription}
                                                    onChange={(e, { value }) => props.handleInputChange(value, index, Constants.TM_MISCELLANEOUS_DESCRIPTION)}
                                                />
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={2} className="p-0 borderWidth-2 borderRight lineHeight-1">
                                            <Form.Field className="h-100 d-flex justify-content-center align-items">
                                                <Icon style={{ color: '#ca1413' }} name="trash" className="pointer iconColor" onClick={() => props.onClickDelete(index, Constants.TM_MISCELLANEOUS)} />
                                            </Form.Field>
                                        </Grid.Column>
                                    </Grid.Row>
                                )))}
                        </Grid>
                    </Form>
                </div>

                {/* TM VOUCHER ATTACHMENT AND APPROVED */}
                <div className="descriptionWidthTable mt-5">
                    <Form>
                        <Grid className="m-0">
                            <Grid.Row className="font-weight-600 p-0">
                                <Grid.Column computer={10} mobile={10} className="p-0">
                                    Attachments
                                    <div className='d-flex w-100 mt-2'>
                                        <ImageUploading multiple value={props.tmVoucherDataEntry.tmVoucherList.tmAttachments}
                                            onChange={(e) => props.selectFiles(e)}>
                                            {({ onImageUpload, isDragging, dragProps }) => (
                                                <div>
                                                    <Button secondary className="borderRadius" size='small' style={isDragging ? { color: 'red' } : undefined} onClick={onImageUpload} {...dragProps} >
                                                        Select Files...
                                                    </Button>
                                                </div>
                                            )}
                                        </ImageUploading>
                                    </div>
                                </Grid.Column>
                                <Grid.Column computer={6} mobile={6} className="p-0">
                                    Approved By
                                    <div className="mt-2">
                                        <Form.Field>
                                            <Form.Input fluid={true} className="" maxLength="20"
                                                value={props.tmVoucherDataEntry.tmVoucherList.approvedBy}
                                                onChange={(e, { value }) => props.handleInputChange(value, 0, Constants.APPROVED_BY)}
                                            />
                                        </Form.Field>
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form>
                    <div className="attachmentImage">
                        {props.tmVoucherDataEntry.tmVoucherList.tmAttachments.length > 0 &&
                            <Fragment>
                                {props.tmVoucherDataEntry.tmVoucherList.tmAttachments.map((attach, attachmentIndex) => (
                                    attach.isActive && (
                                        <div key={attachmentIndex} >
                                            <img src={Constants.DATA_BASE64 + attach.attachmentContent} className='modalSubImage pointer' alt="" onClick={() => props.viewOrCloseAttachment(true, attach)} />
                                            <div className="image-item__btn-wrapper attachmentPointer">
                                                <Icon name="close" onClick={() => props.removeAttachment(attachmentIndex)}></Icon>
                                            </div>
                                        </div>
                                    )))
                                }
                            </Fragment>
                        }
                    </div>
                </div>

                <TMVoucherSignature
                    clearSignature={props.clearSignature}
                    signatureRef={props.tmVoucherDataEntry.signatureRef}
                    tmVoucherSignature={props.tmVoucherDataEntry.tmVoucherList.tmVoucherSignature}
                    hasSignature={props.tmVoucherDataEntry.tmVoucherList.hasSignature}
                    status={props.tmVoucherDataEntry.tmVoucherList.status}
                />
            </Segment>

            {/* TM VOUCHER SAVE AND BACK BUTTON */}
            <Segment>
                <div className='d-flex align-items justify-content-between btnFooter'>
                    <Button secondary className="borderRadius w-10" size='small' onClick={props.onClickBackButton}>{Constants.BUTTON_BACK}</Button>
                    <Button disabled={props.tmVoucherDataEntry.isSaveButtonDisabled || props.tmVoucherDataEntry.tmVoucherList.id === 0} type="button" secondary className="borderRadius w-10" size='small' onClick={() => props.onClickSaveTMVoucher()}>{Constants.TM_VOUCHER_SAVE}</Button>
                </div>
            </Segment>

            {/* DELETE CONFIRMATION POPUP */}
            {
                props.tmVoucherDataEntry.isDeleteConfirmationPopupVisible &&
                <Modal
                    open={props?.tmVoucherDataEntry?.isDeleteConfirmationPopupVisible}
                    closeOnDimmerClick={false}
                    size='tiny'
                >
                    <Modal.Header className="headerColor text-color text-center"> {props.tmVoucherDataEntry.deleteConfirmationHeader}</Modal.Header>
                    <Modal.Content scrolling style={{ minHeight: "auto" }}>
                        {props.tmVoucherDataEntry.deleteConformationMessage}
                    </Modal.Content>
                    <Modal.Actions className="d-flex justify-content-between">
                        <Button secondary onClick={props.onCancelDeleteConfirmation} className="borderRadius w-25 ml-0" size='small' >
                            {Constants.CANCEL_BUTTON}
                        </Button>
                        <Button secondary onClick={() => props.onClickDeleteConfirmation()} className="borderRadius w-25 mr-0" size='small' >
                            {Constants.DELETE_BUTTON}
                        </Button>
                    </Modal.Actions>
                </Modal>
            }

            {props.tmVoucherDataEntry.isShowLoader && <Loader />}
        </Segment.Group>
    )

    return (
        <Fragment>
            {DataEntryPage()}
            {props.tmVoucherDataEntry.isShowImageViewer &&
                <AttachmentViewer attachmentName={props.tmVoucherDataEntry.selectedAttachment.attachmentName}
                    attachmentContent={props.tmVoucherDataEntry.selectedAttachment.attachmentContent}
                    closeAttachmentViewer={() => props.viewOrCloseAttachment()} />
            }
            {props.tmVoucherDataEntry.isShowTMVoucherConfirmation &&
                <ConfirmationPopup
                    isShowConfirmation={props.tmVoucherDataEntry.isShowTMVoucherConfirmation}
                    confirmationHeader={Constants.CONFIRMATION}
                    confirmationMessage={Constants.CONFIRMATION_POPUP_MESSAGE}
                    yesText={Constants.YES_TEXT}
                    noText={Constants.NO_TEXT}
                    isShowYes={true}
                    isBtnDisabled={props.tmVoucherDataEntry.isSubmitButtonDisabled}
                    onClickCloseBtn={() => props.goOrCloseConfirmation()}
                    onClickYesBtn={() => props.goOrCloseConfirmation(true)}
                />
            }
            {props.tmVoucherDataEntry.isShowTMVoucherSignatureValidation &&
                <ConfirmationPopup
                    isShowConfirmation={props.tmVoucherDataEntry.isShowTMVoucherSignatureValidation}
                    confirmationHeader={Constants.WARNING_HEADER_MESSAGE}
                    confirmationMessage={Constants.PLEASE_ENTER_SIGNATURE}
                    noText={Constants.BUTTON_BACK}
                    isShowYes={false}
                    onClickCloseBtn={() => props.closeValiationPopups()}
                />
            }
        </Fragment>
    );
}

export default TmVoucherDataEntryComponent;

TmVoucherDataEntryComponent.displayName = "TmVoucherDataEntryComponent";